import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, Switch,
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, Grid, GridItem,
    SelectField, 
    } from "@chakra-ui/react";
  import { TopDisplay,UploadButton } from "../../../../components";
  import { IoMdAdd as AddIcon } from "react-icons/io";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState, useEffect } from "react";
  import styled from "@emotion/styled";
  import {TopLink} from '../';
  import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
  import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
  import { atom, useAtom } from 'jotai';
  import { Formik,Form,Field } from "formik";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import ViewSetting from '../Modal/ViewSetting';
  import apiCall from '../../../../utils/apiCall';
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import * as Yup from 'yup';
  import moment from "moment";
  import { Loader } from "../../../../customs";
  import {TablePopUp, DateFilter} from '../../../../components';
  import ReactPaginate from 'react-paginate';
  import { TbReload as ReloadIcon } from "react-icons/tb";
import { format } from "date-fns";
  
  
  const HeadStyle={
    borderBottom:"1px solid var(--cipm-light-green)",
    padding:'15px 5px',
    color:'var(--dark-green-color)',
  }
  
  const DataStyle = {
    padding:'5px 5px',
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type > *{
      display:none;
    }
    :hover > td{
      background-color:var(--table-highlight);
      &:last-of-type > *{
        display:block;
      }
    } 
    &.active > td:last-of-type > *{
      display:block !important;
    }  
  `
  const LookUpSetUpAtom = atom<number | null>(null);
  
  export default function LookUpSetUp() {
    const [hide,set_hide] = useState<boolean>(true);
    const [active] = useAtom<number | string | null>(LookUpSetUpAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);

    const {isLoading,data:lookUpConfig} = useQuery(["looku-setup"],{
      queryFn: async ()=> await apiCall().get(`/MembershipSetUp/member/GetAllLookUps`),
      select: (data) => data?.data?.Data?.filter((eData:any) => eData.CodeName.toLowerCase() === 'ExamDefermentPercentage'.toLowerCase()),
      onSuccess(data) {
          //console.log(data,' look-up setup')
      },
    })
    const [search,set_search] = useState('');
    const [filter_data,set_filter_data] = useState<any>(lookUpConfig);
  
    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data(lookUpConfig)
      }
      else set_filter_data(lookUpConfig)
    }
    const itemsPerPage = 10;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
     useEffect(()=>{
      set_filter_data(lookUpConfig)
    },[lookUpConfig])
  
    const handleAddFee = () =>{
        set_modal({
          header:'ExamDeferment % Config',
          content:<AddType />
        })
        set_open(true);
        // set_notification({
        //   type:'success',
        //   message: 'Added Successfully'
        // })
        // set_Nopen(true);
    }
       
     
    return (
      <>
      {isLoading?<Loader />:
  
      <Box>
        <TopLink />
        <TopDisplay label="ExamDeferment % Config" button_array={[
  
            // <Button onClick={handleAddFee} bg="var(--dark-green-color)" color="var(--white-color)"  type="button" leftIcon={<AddIcon/>}>Add ExamDeferment Config</Button>
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
              <Text style={{position:'absolute',zIndex:'1',
              right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></Text>
            </InputGroup>  
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All percentage Configuration</Heading>
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
        
       {  filter_data && filter_data.length > 0 ? <TableContainer sx={{overflowY:'visible',h:'max-content'}}  mt="20px">
            <Table sx={{overflowY:'visible'}} size='sm'>
              <Thead>
                <Tr >
                  {/* <Th sx={HeadStyle}>ID</Th> */}
                  <Th sx={HeadStyle}>Code Name</Th>
                  <Th sx={HeadStyle}>Value</Th>
                  <Th sx={HeadStyle}>Date Created</Th>
                  <Th sx={HeadStyle}>Date Lastmodified</Th>
                  {/* <Th sx={HeadStyle}>CreatedBy</Th> */}
                  <Th sx={HeadStyle}>Active status</Th>

                  <Th sx={HeadStyle} w="50px" ></Th>
                </Tr>
              </Thead>
              <Tbody sx={{overflowY:'visible'}}>
                {currentItems.map((efeeSetUp:any,index:number) =><ROWSTYLE className={efeeSetUp.Id === active?'active':''} key={efeeSetUp.Id}>
                  {/* <Td sx={DataStyle}>{efeeSetUp.Id}</Td> */}
                  <Td sx={DataStyle}>{efeeSetUp.CodeName || 'N/A'}</Td>
                  <Td sx={DataStyle}>{efeeSetUp.Value || 'n/a'}</Td>
                  <Td sx={DataStyle}>{format(new Date(efeeSetUp.CreatedDate), "dd/MM/yyyy")|| 'N/A'}</Td>
                  <Td sx={DataStyle}>{format(new Date(efeeSetUp.LastModified), "dd/MM/yyyy")|| 'N/A'}</Td>
                  {/* <Td sx={DataStyle}>{efeeSetUp.CreatedBy|| 'N/A'}</Td> */}
                  <Td sx={DataStyle}>{efeeSetUp.ActiveStatus? 'Yes':'No'}</Td>


                  <Td sx={DataStyle} w="50px" h="50px">
                    <TempPopUp index={efeeSetUp.Id} data={efeeSetUp}/>
                  </Td>
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Special Fees SetUp'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
    }
      </>
      
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  
  const AddSchema = Yup.object({
    Id:Yup.number(),
    CodeName:Yup.string().required(),
    Value:Yup.number().required(),
    ActiveStatus:Yup.string(),
  });
  
  const AddType = (props:any) =>{
    // console.log({...props},'data')

    const queryClient = useQueryClient();
    const [status,set_status] = useState(props.ActiveStatus?props.ActiveStatus.toString(): 'false');
    const [,set_open] = useAtom(openAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const {mutate:addUpdate,isLoading} = useMutation({
      mutationKey:['new-lookup-config'],
      mutationFn:async (data:any)=> {
        return  await apiCall().post(`/MembershipSetUp/member/CreateUpdateLookUp`,data)},
      onSuccess:(data)=>{
        //console.log(data,'new data')
        set_notification({
          type:'success',
          message:data?.data?.Message || 'ExamDeferment % Added Successfully'
        })
        set_Nopen(true);
        queryClient.invalidateQueries({
          queryKey:['looku-setup']
        })
      },
      onError(error:any){
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
    } )
    // console.log(allFeeType,'all fee type')
    return (
      <>
        <Formik
            initialValues={{
              CodeName:props.CodeName || '',
              Value:props.Value || '',
              Id:props.Id||0,
              ActiveStatus:props.ActiveStatus?props.ActiveStatus.toString():'false'


            }}
            validationSchema={AddSchema}
            onSubmit={(values:any) => {
              //console.log('clicked')
              const data = {
                Id:props.Id || 0,
                CodeName:values.CodeName,
                Value:values.Value.toString(),
                ActiveStatus:status === 'true'?true:false,
              };
              // console.log(data,'form data')
  
              addUpdate(data);
            }}
          >
           {(formik:any)=>{
          const {errors,values} = formik;
          // console.log(values,'values');
          // console.log(errors,'errors')
          return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">
                  <Input as={Field} 
                    placeholder="Code Name"
                    name="CodeName"
                    type="text"
                    disabled
                  />
                   <Input as={Field} 
                    placeholder="Value"
                    name="Value"
                    type="number"
                  />
                  < Select
                    placeholder="Select Status"
                    name="ActiveStatus"
                    disabled
                    onChange={(e:any)=>set_status(e.target.value)}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>

                  </Select>
                  <Box color="red" fontSize=".7rem">
                    {errors && Object.values(errors).map((error:any,index:number) => <Box key={index}>{error}</Box>)}
                  </Box>
                  <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                    {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
                  
                
              </Form>
            )}}
          </Formik>
      </>
    )
  }
  
  const TempPopUp = (props:any) =>{
    const index = props.index;
    const data = props.data;
    const [active,set_active] = useAtom(LookUpSetUpAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const queryClient = useQueryClient();
    // const {mutate:deleteFee,isLoading} = useMutation({
    //   mutationKey:['delete-special-Fee'],
    //   mutationFn:async () => await apiCall().get(`/exam/setup/specialExamFee/${data?.Id}/delete`),
    //   onSuccess(data:any) {
    //     queryClient.invalidateQueries({queryKey:["special-fee"]})
    //     set_notification({
    //       type:'success',
    //       message:data?.data?.Message || 'Deleted Successfully'
    //     })
    //     set_Nopen(true);
    //   },
    //   onSettled(){
    //     set_open(false);
    //   }
    // })
  
    const handleClick = () =>{
      if(index === active){
        set_active(null);
        return;
      }
      else{
        set_active(index);
      }
    }
    const handleView= () =>{
      set_modal({
        header:'View Deferment SetUp',
        content:<Grid>
          {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
            <Text> Id</Text>
            <Text>{data?.Id}</Text>
          </GridItem > */}
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">CodeName:</Text>
            <Text>{data?.CodeName}</Text>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">Value:</Text>
            <Text>{data?.Value}</Text>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">Created Date:</Text>
            <Text>{format(new Date(data?.CreatedDate), "dd/MM/yyyy")|| 'N/A'}</Text>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">LastModified:</Text>
            <Text>{format(new Date(data?.LastModified), "dd/MM/yyyy")|| 'N/A'}</Text>
          </GridItem>
          {/* <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text>Created By</Text>
            <Text>{data?.CreatedBy}</Text>
          </GridItem> */}
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">ActiveStatus:</Text>
            <Text>{data?.ActiveStatus?'Yes':'No'}</Text>
          </GridItem>
         
        </Grid>
      })
      set_open(true);
      handleClick();
    }
    const handleEdit = () =>{
      handleClick();
      set_modal({
        header:'Edit Deferment Config',
        content:<AddType {...data}/>
      });
      set_open(true);
      handleClick();
      
    }
    // const handleDelete = () =>{
    //   set_modal({
    //     header:'Delete Special Fee SetUp',
    //     content:<Grid gap="20px">
    //       <GridItem>Are you Sure you want to delete this Special fee Setup</GridItem>
    //       <GridItem as={Flex} justify="space-between" p="20px 0">
    //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
    //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
    //         <Button disabled={isLoading} 
    //           variant="outline" bg="var(--white-color)"
    //           onClick={()=>set_open(false)}
    //           border="1px solid var(--dark-green-color)"
    //           color="var(--dark-green-color)" >Cancel</Button>
    //       </GridItem>
    //     </Grid>
    //   });
    //   set_open(true);
    // }
    
    return (
      <TablePopUp click={handleClick} options={[
        {label:'View Cofig',click:handleView},
        {label:'Edit Config',click:handleEdit},
        // {label:'Delete Fee',click:handleDelete}
      ]} />
    )
  }
  
  
  